import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AssetCustomView } from "domain/asset-management/assets";

export interface AssetViewsState {
    views: AssetCustomView[] | null;
}

const INITIAL_STATE: AssetViewsState = {
    views: null,
};

const VIEW_SLICE = createSlice({
    name: "assetViewsStore",
    initialState: INITIAL_STATE,
    reducers: {
        setViews(state, action: PayloadAction<AssetCustomView[]>) {
            state.views = action.payload;
        },
        removeViews(state) {
            state.views = null;
        },
    },
});

export const { setViews, removeViews } = VIEW_SLICE.actions;

export default VIEW_SLICE.reducer;
